import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const postRichTextVersion = ({
  editorState,
  userId,
  entityId,
  entityType,
  parentId = null,
}) => {
  const richTextBody = {
    data: {
      type: 'rich_text',
      attributes: {
        editor_content: editorState,
      },
      relationships: {
        author: {
          data: {
            id: userId,
            type: 'user',
          },
        },
        parent: {
          data: {
            id: parentId,
            type: 'rich_text',
          },
        },
      },
    },
  }

  return HttpClient().post(
    `/rich_texts/v1/${entityType}/${entityId}`,
    richTextBody
  )
}

const createRichTextVersion = (options) => (dispatch) =>
  postRichTextVersion(options)
    .then((response) => {
      const body = response.data
      if (body.data) dispatch(loadJsonApiEntities(body))

      return body.data
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default createRichTextVersion
